





























import {Component, Prop, Vue} from 'vue-property-decorator'
import {GithubOrganization} from '@/model/resource/GithubOrganization'
import {GithubRepository} from '@/model/resource/GithubRepository'
import {GithubOrganizationSocialType} from '@/model/resource/GithubOrganizationSocialType'
import CDOrganizationInformation from '@/components/communityDevelopment/CDOrganizationInformation.vue'
import CDOrganizationSocialLinks from '@/components/communityDevelopment/CDOrganizationSocialLinks.vue'
import CDRepositoryDescription from '@/components/communityDevelopment/CDRepositoryDescription.vue'

@Component({
  components: {
    CDOrganizationInformation,
    CDOrganizationSocialLinks,
    CDRepositoryDescription,
  },
})
export default class CDOrganizationMobileInfoCard extends Vue {
  @Prop({type: GithubOrganization, required: true})
  selectedOrganization!: GithubOrganization

  @Prop({type: GithubRepository, default: null})
  selectedRepository!: GithubRepository | null

  @Prop({type: Array, default: () => []})
  socialTypes!: GithubOrganizationSocialType[]
}
